// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
import type * as SchemaTypes from '../../../../index';

import { gql } from 'graphql-tag';
import { ReadyToGoRingLinkFragmentDoc } from '../../../../../../router/fragments/readyToGoRingLink.fragment.generated';
export const ReadyToGoRingVariationsFragmentDoc = gql`
    fragment readyToGoRingVariations on CatalogueReadyToGoRing {
  catalogueCode
  gemType
  carat
  ...readyToGoRingLink
}
    ${ReadyToGoRingLinkFragmentDoc}`;